import { AsyncButton, SaveStates } from '@infl-ts/ui-advocate-components';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import * as DE from '@nll/datum/lib/DatumEither';
import * as E from 'fp-ts/Either';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";

var JoinGroup = function JoinGroup(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      prospect = _ref.prospect;
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(AsyncButton, {
      status: mutationValue,
      disabled: DE.isSuccess(completeStageStatus),
      onClick: function onClick() {
        return completeStage({
          influitiveGroupJoinInput: {
            stageID: stage.id,
            activityID: activity === null || activity === void 0 ? void 0 : activity.id
          }
        });
      },
      text: ['Joining Group...', 'Joined', stage.completionText || 'Join Group', stage.completionText || 'Join Group']
    }),
    "data-element": "StageLayout",
    "data-component": "JoinGroup",
    "data-source-file": "index.tsx"
  });
};

export default JoinGroup;